import { Pipe, PipeTransform } from '@angular/core'
import { ContractType } from '@wm-front/admin/graphql'

declare const $localize: any

@Pipe({
  name: 'contractType',
  standalone: true,
})
export class ContractTypePipe implements PipeTransform {
  /** Transform contract type into localised string
   * @param { ContractType } value
   * @param { boolean } fullName
   * @returns { string }
   */
  public transform(value?: ContractType, fullName?: boolean): string {
    switch (value) {
      case ContractType.Basic:
        if (!fullName) {
          return $localize`:Contract type label | Contract type basic@@contractTypePipeBasicLabel:Minimal`
        } else {
          return $localize`:Contract type label | Contract type basic full name@@contractTypePipeBasicFullNameLabel:Contrat minimal`
        }
      case ContractType.Advanced:
        if (!fullName) {
          return $localize`:Contract type label | Contract type basic@@contractTypePipeAdvancedLabel:Avancé`
        } else {
          return $localize`:Contract type label | Contract type basic full name@@contractTypePipeAdvancedFullNameLabel:Contrat avancé`
        }
      case ContractType.ClientSpecific:
        if (!fullName) {
          return $localize`:Contract type label | Contract type basic@@contractTypePipeClientSpecificLabel:Spécifique client`
        } else {
          return $localize`:Contract type label | Contract type basic full name@@contractTypePipeClientSpecificFullNameLabel:Contrat specifique client`
        }
      case ContractType.Comprehensive:
        if (!fullName) {
          return $localize`:Contract type label | Contract type basic@@contractTypePipeClientComprehensiveLabel:Étendu`
        } else {
          return $localize`:Contract type label | Contract type basic full name@@contractTypePipeComprehensiveFullNameLabel:Contrat étendu`
        }
      default:
        return ''
    }
  }
}
